<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">My Orders</h1>

    <daily-limit-notice v-if="message" :message="message"></daily-limit-notice>
    <daily-limit-notice info v-if="!canPlaceNewOrders" message="Kindly note that new orders can be placed after your current orders are cleared."></daily-limit-notice>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset" onlySearch>
      </search-filter>

      <inertia-link class="btn-primary" :href="route('my-orders.create')" v-if="isOpenForBusiness && canPlaceNewOrders">
        <span>Create</span>
        <span class="hidden md:inline"> Order</span>
      </inertia-link>

    </div>

    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4">Customer Account/Shop</th>
          <th class="px-6 pt-6 pb-4">Status</th>
          <th class="px-6 pt-6 pb-4">Time</th>
        </tr>
        <tr v-for="order in orders" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('my-orders.show', order.id)" tabindex="-1">
              {{ order.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('my-orders.show', order.id)" tabindex="-1">
              {{ order.customer_account.name }} {{ order.delivery_address }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('my-orders.show', order.id)" tabindex="-1">
              {{ order.status }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('my-orders.show', order.id)" tabindex="-1">
              {{ order.created_at | localDateTime }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('my-orders.show', order.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="orders.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No orders found.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Customers/Layout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import DailyLimitNotice from '@/Shared/DailyLimitNotice'

export default {
  metaInfo: { title: 'My Orders' },
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    DailyLimitNotice
  },
  props: {
    orders: Array,
    filters: Object,
    isOpenForBusiness: Boolean,
    canPlaceNewOrders: Boolean,
    message: String
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        type: this.filters.type,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('my-orders', Object.keys(query).length ? query : { remember: 'forget' }), {}, { preserveState: true })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
